import React, { useEffect, useState } from 'react';
import SectionTitle from '../../yourProperties/Title';
import Card from '../../../../muiComponents/Card';
import DotIcon from '../../../components/DotIcon';
import Tooltip from '../../../../muiComponents/Tooltip';
import {
    useContractDetail,
    useContractDetailData,
} from '../../../contextsProperty/ContextContractDetail';
import {
    Alert,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Tabs,
} from '@mui/material';
import RatesTableHeader from './RatesTableHeader';
import Menu from '../../components/Menu';
import Button from '../../../../muiComponents/Button';
import useTranslate from '../../../../customHooks/useTranslate';
import {
    ContractDetailPanelNames,
    IContractMealPlanState,
} from '../../../../types/contracts/contractTypes';
import { getInitialStateOccupancyRate } from '../../../../utils/contractUtils/contractUtils';
import RatesPanel from './panels/RatesPanel';
import DeletePopUp from './DeletePopUp';
import { useNotification } from '../../../../contexts/NotificationsContext';
import { FeedbackMessages } from '../../../../utils/commonVariables/messages';
import LoadingSection from './LoadingSection';
import useUserProfile from '../../../../customHooks/useUserProfile';

const RateDates = () => {
    const {
        isBlockedContract,
        isMainInfoEmpty,
        openedPanel,
        handleOpenRateDatePanel,
        handleOpenPanel,
        handleLoadingView,
        handleSaveRateDate,
        isLoadingView,
    } = useContractDetail();
    const {
        mealPlans,
        rooms,
        seasons,
        rateDates,
        currency,
        idRateScopeModel,
        rateScopeModel,
        ageSegments,
    } = useContractDetailData();
    const translate = useTranslate();
    const { setErrorMessage, setSuccessMessage } = useNotification();
    const { readOnlyUser } = useUserProfile();

    const [deletePopUpVisible, setDeletePopUpVisible] = useState('');

    const [selectedTab, setSelectedTab] =
        useState<IContractMealPlanState | null>(null);

    useEffect(() => {
        if (mealPlans.length) {
            setSelectedTab(mealPlans[0]);
        }
    }, [mealPlans]);

    const handleCloseRateDatePanel = () => {
        handleOpenPanel(null);
    };

    return (
        <>
            {deletePopUpVisible && !readOnlyUser && (
                <DeletePopUp
                    open={!!deletePopUpVisible}
                    onSave={async () => {
                        const deletedRate = rateDates.find(
                            rate => rate.id === deletePopUpVisible
                        );
                        if (!deletedRate) return;
                        try {
                            handleLoadingView(true);
                            await handleSaveRateDate({
                                ...deletedRate,
                                Deleted: true,
                            });
                            setSuccessMessage(
                                FeedbackMessages.COMMON_SUCCESS_DELETE
                            );
                        } catch (error) {
                            setErrorMessage(FeedbackMessages.COMMON_ERROR);
                        } finally {
                            handleLoadingView(false);
                            setDeletePopUpVisible('');
                        }
                    }}
                    onCancel={() => {
                        setDeletePopUpVisible('');
                    }}
                ></DeletePopUp>
            )}
            {openedPanel === ContractDetailPanelNames.RATES && (
                <RatesPanel
                    open={openedPanel === ContractDetailPanelNames.RATES}
                    onClose={handleCloseRateDatePanel}
                />
            )}
            <section className='contract-detail__section'>
                <div className='flex-between flex-align-center'>
                    <SectionTitle text='static_rates' />
                </div>
                {isLoadingView ? (
                    <LoadingSection />
                ) : mealPlans.length && rooms.length && seasons.length ? (
                    <Card className='overflow-x-auto'>
                        <Tabs
                            value={selectedTab}
                            variant='scrollable'
                            scrollButtons
                            allowScrollButtonsMobile
                            className='rates-table__tabs'
                        >
                            {mealPlans?.map(plan => (
                                <Tab
                                    key={'plan' + plan.id}
                                    label={plan.name}
                                    value={plan}
                                    onClick={() => setSelectedTab(plan)}
                                    className='rates-table__tab'
                                    icon={
                                        <Tooltip
                                            titleText={
                                                plan.enabled
                                                    ? 'enabled'
                                                    : 'disabled'
                                            }
                                        >
                                            <div>
                                                <DotIcon
                                                    truthy={plan.enabled}
                                                    falsy={!plan.enabled}
                                                />
                                            </div>
                                        </Tooltip>
                                    }
                                    iconPosition='start'
                                />
                            ))}
                        </Tabs>

                        <Table>
                            <RatesTableHeader seasons={seasons} />
                            <TableBody>
                                {rooms.map(room => {
                                    const rates = rateDates.filter(
                                        rate =>
                                            rate.idRoom === parseInt(room.id) &&
                                            rate.idMealPlan ===
                                                parseInt(selectedTab?.id || '')
                                    );
                                    return (
                                        <TableRow
                                            key={'room' + room.id}
                                            className='contact__rate-dates--row'
                                        >
                                            <TableCell className='rates-table__cell'>
                                                <Tooltip
                                                    placement='top-start'
                                                    titleText={
                                                        room.enabled
                                                            ? 'enabled'
                                                            : 'disabled'
                                                    }
                                                >
                                                    <div className='flex flex-align-center gap-5'>
                                                        <DotIcon
                                                            truthy={
                                                                room.enabled
                                                            }
                                                            falsy={
                                                                !room.enabled
                                                            }
                                                        />
                                                        {room.name}
                                                    </div>
                                                </Tooltip>
                                            </TableCell>
                                            {seasons?.map(season => {
                                                const cellValue = rates.find(
                                                    rate =>
                                                        rate.idSeason ===
                                                        parseInt(season.id)
                                                );
                                                return (
                                                    <TableCell
                                                        key={
                                                            'rate-date' +
                                                            season.id
                                                        }
                                                        className='rates-table__cell'
                                                    >
                                                        <div className='table-cell__content'>
                                                            {cellValue ? (
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            width: '100px',
                                                                            textAlign:
                                                                                'center',
                                                                        }}
                                                                    >
                                                                        {`${cellValue.baseRate} ${currency}`}
                                                                    </p>
                                                                    <Menu
                                                                        menuItems={[
                                                                            {
                                                                                text: readOnlyUser
                                                                                    ? 'view'
                                                                                    : 'edit',
                                                                                icon: readOnlyUser
                                                                                    ? 'Visibility'
                                                                                    : 'Edit',
                                                                                onClick:
                                                                                    () =>
                                                                                        handleOpenRateDatePanel(
                                                                                            {
                                                                                                ...cellValue,
                                                                                                __isChanged:
                                                                                                    true,
                                                                                            }
                                                                                        ),
                                                                            },
                                                                            {
                                                                                text: 'delete',
                                                                                icon: 'Delete',
                                                                                disabled:
                                                                                    isBlockedContract ||
                                                                                    readOnlyUser,
                                                                                onClick:
                                                                                    () => {
                                                                                        setDeletePopUpVisible(
                                                                                            cellValue.id
                                                                                        );
                                                                                    },
                                                                            },
                                                                        ]}
                                                                    />
                                                                </>
                                                            ) : (
                                                                <Button
                                                                    disabled={
                                                                        isBlockedContract ||
                                                                        readOnlyUser
                                                                    }
                                                                    variant='outlined'
                                                                    startIcon={
                                                                        'Add'
                                                                    }
                                                                    onClick={() => {
                                                                        const mealPlan =
                                                                            selectedTab;

                                                                        const data =
                                                                            getInitialStateOccupancyRate(
                                                                                idRateScopeModel,
                                                                                rateScopeModel,
                                                                                room,
                                                                                mealPlan as IContractMealPlanState,
                                                                                season,
                                                                                ageSegments
                                                                            );
                                                                        handleOpenRateDatePanel(
                                                                            {
                                                                                ...data,
                                                                                __isAdded:
                                                                                    true,
                                                                                __isChanged:
                                                                                    true,
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    {translate(
                                                                        'add'
                                                                    )}
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </Card>
                ) : (
                    <Card
                        className='contract-card__empty flex-center width100perc'
                        style={{ minHeight: '150px', padding: '10px 20px' }}
                    >
                        {isMainInfoEmpty ||
                        !rooms.length ||
                        !mealPlans.length ||
                        !seasons.length ? (
                            <Alert severity='info' sx={{ width: '100%' }}>
                                {translate('add_info_collections_first')}
                            </Alert>
                        ) : (
                            <Button
                                startIcon='Add'
                                // variant='textIcon'
                                onClick={() => {
                                    // handleOpenSeasonPanel();
                                }}
                            >
                                {translate('add')}
                            </Button>
                        )}
                    </Card>
                )}
            </section>
        </>
    );
};

export default RateDates;
